import { trackCustomEvent } from "gatsby-plugin-google-analytics"

export const useCreateAnalyticsEvent = (label: string): (() => void) => {
  return () => {
    trackCustomEvent({
      category: "Button",
      action: "Click",
      label,
    })
  }
}
